import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../redux/reducers/root";
import { reportsAccumulatedSelector } from "../../redux/selectors/reports";
import { LAST_WEEK } from "../constants";
import Line from "../reports/chart";
import { convertToNivoData } from "../reports/utils";
import Error from "../reports/error";

interface Props {
  doctorId: number;
}

const BiddingReport = ({ doctorId }: Props) => {
  const reports = useSelector((state: State) => reportsAccumulatedSelector(state, doctorId, LAST_WEEK));
  const pageVisitsData = convertToNivoData(reports.pageVisits, `pageVisitsData-last-week`);

  return (
    <div className="mt-4 mb-6 text-sm font-bold rounded-md shadow h-68 bg-pkc-white ">
      {pageVisitsData?.length > 0 && pageVisitsData[0].data.length > 0 ? (
        <Line
          tooltip={({ point }) => <span className="p-1 rounded bg-pkc-white">{`${point?.data?.y} بازدید`}</span>}
          color="#29f"
          title="بازدید صفحه"
          icon="fa fa-eye"
          data={pageVisitsData}
        />
      ) : (
        <Error title="بازدید صفحه" />
      )}
    </div>
  );
};

export default BiddingReport;
